import  { TimeMode } from '~/models/mode.model';
import i18n from '~/i18n';

export const DefaultMode: TimeMode[] = [
    {
        label: i18n.global.t('time.n-hour'),
        name: 'hours',
        timeUnit: 'hour',
        time: 6,
    },
    {
        label: i18n.global.t('time.n-week'),
        name: 'week',
        timeUnit: 'week',
        time: 6,
    },
    {
        label: i18n.global.t('time.n-month'),
        name: 'month',
        timeUnit: 'month',
        time: 6,
    }
]